import { Box, ThreeViewLayout } from '@ds/coolshop';
import { usePimSidebarOpen } from '@src/_new/hooks/usePimSidebarOpen';
import { usePimSidebarWidth } from '@src/_new/hooks/usePimSidebarWidth';
import { SelectedNode } from '@src/modules/hierarchy/types';
import { SettingsContext } from '@src/modules/setting/SettingsContext';
import { useContext, useState } from 'react';

import TranslateNode from './TranslateNode';
import TranslationsNavigation from './TranslationsNavigation';

export const path = 'translations';

export const encodeParam = (param: string) => btoa(encodeURIComponent(param));

export function useTranslations() {
    const { enableContentTranslation } = useContext(SettingsContext);
    return {
        canTranslate: enableContentTranslation, // TODO: check if user can translate
    };
}

export default function Translations(): JSX.Element {
    const [selectedNode, setSelectedNode] = useState<SelectedNode>();
    const sidebarWidth = usePimSidebarWidth();
    const sidebarOpen = usePimSidebarOpen();

    return (
        <ThreeViewLayout
            overrideLeftWidth={sidebarWidth}
            leftOpen={sidebarOpen}
            left={
                <TranslationsNavigation
                    selectedNode={selectedNode}
                    setSelectedNode={setSelectedNode}
                />
            }
            center={
                <Box height="100%" overflowY="auto" position="relative" zIndex={0}>
                    <TranslateNode selectedNode={selectedNode} />
                </Box>
            }
        />
    );
}
